<template>
  <div class="row">
    <div class="form-group col-md-12">
      <w-input :model="schema.mdokId" @input="loadDocumentName(schema.mdokId.$model)" />
    </div>

    <div v-if="documentName" class="form-group col-md-12">
      <p>
        Wybrano dokument: <b>{{ documentName }}</b>
      </p>
    </div>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import { mdokDocumentMixin } from '@/mixins/mdokDocument';

// @vuese
// Formularz wprowadzenia UID z MDOK
// @group ActionData
export default {
  components,
  mixins: [mdokDocumentMixin],
  props: {
    // schema
    schema: { type: Object, required: true }
  }
};
</script>
